export default "__VITE_ASSET__cd925f96__"